import React, { useState, useEffect } from 'react';
import { cn } from '../../../../lib/utils';

const OrderStatusComponent = ({ orderData }) => {
    const deliveryArray = [
        {
            id: '1',
            status: 'Order Pending',
            label: 'Order Pending',
            imgUrl: '/assets/images/order/placed.gif',
        },
        {
            id: '2',
            status: 'Order Placed',
            label: 'Order Placed',
            imgUrl: '/assets/images/order/placed.gif',
        },
        {
            id: '3',
            status: 'Order Accept',
            label: 'Order Accepted',
            imgUrl: '/assets/images/order/confirm.gif',
        },
        {
            id: '4',
            status: 'Order Processing',
            label: 'Order Processing',
            imgUrl: '/assets/images/order/preparing_order.gif',
        },
        {
            id: '5',
            status: 'Out for Delivery',
            label: 'Out for Delivery',
            imgUrl: '/assets/images/order/out_for_delivery.gif',
        },
        {
            id: '6',
            status: 'Delivered',
            label: 'Order Delivered',
            imgUrl: '/assets/images/order/delivered.gif',
        },
        {
            id: '7',
            status: 'Canceled',
            label: 'Order Canceled',
            imgUrl: '/assets/images/order/rejected.gif',
        },
        {
            id: '8',
            status: 'Rejected',
            label: 'Order Rejected',
            imgUrl: '/assets/images/order/rejected.gif',
        },
    ];

    const [orderStatus, setOrderStatus] = useState(orderData?.status);

    useEffect(() => {
        setOrderStatus(orderData?.status);
    }, [orderData]);

    const currentStatus = deliveryArray.find((status) => status.id == orderStatus);
    console.log({ orderStatus }, currentStatus);

    return (
        <div className="mb-4">
            <div className="text-center mb-4">
                {currentStatus ? (
                    <>
                        <h4 className="text-xl font-medium">{currentStatus.label}</h4>
                        <img className="h-32 mx-auto mb-3" src={currentStatus.imgUrl} alt={currentStatus.label} />
                    </>
                ) : (
                    <h4 className="text-xl font-medium">Loading...</h4>
                )}
            </div>
            <div className="mb-8">
                <ul className="flex items-center justify-between px-2 mx-2 mb-[70px] relative before:absolute before:top-0 before:left-0 before:w-full before:h-1 before:bg-primary">
                    {deliveryArray.map((delivery, index) => (
                        <li
                            key={delivery.id}
                            className={cn(
                                'db-order-status relative before:absolute before:-top-2 before:left-1/2 before:-translate-x-1/2 before:w-5 before:h-5 before:rounded-full before:border-[3px] before:border-primary before:bg-white',
                                orderStatus == delivery.id ? 'check' : ''
                            )}>
                            <span className="absolute -bottom-12 left-1/2 -translate-x-1/2 text-[10px] leading-4 text-center text-heading">{delivery.label}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default OrderStatusComponent;
